import { useQuery } from "@tanstack/react-query";
import { fetchFanoutStudies, fetchFanoutStudy } from "../api/index.js";
import { queryKeys } from "../query-keys.js";

/** Query fan-out studies. */

export function useFanoutStudies(workspaceId: string, enabled: boolean) {
  return useQuery({
    queryKey: queryKeys.fanoutStudies(workspaceId),
    queryFn: () => fetchFanoutStudies(workspaceId),
    enabled,
  });
}

export function useFanoutStudy(workspaceId: string, studyId: string | null) {
  return useQuery({
    queryKey: queryKeys.fanoutStudy(workspaceId, studyId ?? ""),
    queryFn: () => fetchFanoutStudy(workspaceId, studyId ?? ""),
    enabled: workspaceId !== "" && studyId !== null,
  });
}
